"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskFields = exports.checkTaskFields = void 0;
const react_1 = require("react");
const core_ui_1 = require("@sierralabs/core-ui");
const user_ui_1 = require("@sierralabs/user-ui");
const useStateNodeByStatus_1 = require("../../hooks/useStateNodeByStatus");
const Workflow_context_1 = require("../../Workflow.context");
const useTaskWorkflow_1 = require("./useTaskWorkflow");
function checkTaskFields(stateNode, user) {
    const { allowedFields = [], groupPermissions = [] } = (stateNode === null || stateNode === void 0 ? void 0 : stateNode.meta) || {};
    // handle group permissions
    const groups = (user === null || user === void 0 ? void 0 : user.groups) && Array.isArray(user.groups) ? user.groups : [];
    const hasGroupPermissions = groupPermissions.length === 0 ||
        !!groups.some(group => groupPermissions.includes(group.id));
    return {
        disabled: (field) => {
            return (!stateNode || !hasGroupPermissions || !allowedFields.includes(field));
        }
    };
}
exports.checkTaskFields = checkTaskFields;
function useTaskFields(task, strictOrOptions = true) {
    var _a;
    const options = typeof strictOrOptions === 'boolean'
        ? { strict: strictOrOptions }
        : strictOrOptions;
    const { strict, token } = options;
    const [debounceError, clearDebouncedError] = (0, core_ui_1.useTimeout)();
    const { user } = (0, user_ui_1.useUserContext)();
    const { setError } = (0, Workflow_context_1.useWorkflowContext)();
    const workflow = (0, useTaskWorkflow_1.useTaskWorkflow)(task, 
    // wrap with useMemo to avoid multiple fetch calls
    (0, react_1.useMemo)(() => (token ? { token } : undefined), [token]));
    const stateNode = (0, useStateNodeByStatus_1.useStateNodeByStatus)(task === null || task === void 0 ? void 0 : task.status, workflow);
    const taskTypeLabel = (_a = task === null || task === void 0 ? void 0 : task.taskType) === null || _a === void 0 ? void 0 : _a.label;
    // disable field if loading, error, or is not part of allowedFields
    const isFieldDisabled = (0, react_1.useCallback)((field) => {
        if (!stateNode) {
            console.warn('isFieldDisabled error: No State Node found.', {
                field,
                workflow,
                taskStatus: task === null || task === void 0 ? void 0 : task.status
            });
            return true;
        }
        return checkTaskFields(stateNode, user).disabled(field);
    }, [stateNode, task, user, workflow]);
    (0, react_1.useEffect)(() => {
        if (strict) {
            debounceError(() => {
                const message = taskTypeLabel
                    ? `No published workflow for "${taskTypeLabel}" type.`
                    : 'No published Workflow for this item.';
                setError(workflow ? undefined : { message, statusCode: 409, error: 'Conflict' });
            }, 300);
        }
    }, [strict, taskTypeLabel, workflow, debounceError, setError]);
    (0, react_1.useEffect)(() => {
        return () => clearDebouncedError();
    }, [clearDebouncedError]);
    return { isFieldDisabled };
}
exports.useTaskFields = useTaskFields;
//# sourceMappingURL=useTaskFields.js.map